import "../../index12.css";
import { jsx as r, jsxs as x } from "react/jsx-runtime";
import { useMemo as k } from "react";
import { i as w, a as t } from "../../type-BFTbooL7.js";
import { _ as c } from "../../cs-piwRuCFZ.js";
import V from "../NumberOutput/index.js";
import y from "../Tooltip/index.js";
import { u as C, g } from "../../common-UUpiO33D.js";
const D = "_bar-chart_3dbpc_1", R = "_bar-row_3dbpc_6", S = "_hoverable_3dbpc_11", T = "_label_3dbpc_17", j = "_bar-track_3dbpc_22", M = "_bar_3dbpc_1", P = "_value_3dbpc_36", e = {
  barChart: D,
  barRow: R,
  hoverable: S,
  label: T,
  barTrack: j,
  bar: M,
  value: P
};
function G(u) {
  const {
    className: h,
    barClassName: f,
    data: l,
    valueSelector: i,
    labelSelector: b,
    tooltipSelector: o,
    keySelector: n,
    maxValue: p,
    maxRows: m = 5,
    compactValue: d
  } = u, _ = k(
    () => (l == null ? void 0 : l.map((a) => {
      const s = i(a);
      if (!w(s))
        return {
          key: n(a),
          value: s,
          label: b(a),
          tooltip: o == null ? void 0 : o(a)
        };
    }).filter(t).sort((a, s) => s.value - a.value).slice(0, m)) ?? [],
    [l, n, i, b, o, m]
  ), v = t(p) ? p : Math.max(..._.map((a) => a.value)), N = v === 0 ? 1 : v;
  return /* @__PURE__ */ r("div", { className: c(e.barChart, h), children: _.map((a) => /* @__PURE__ */ x(
    "div",
    {
      className: c(t(a.tooltip) && e.hoverable, e.barRow),
      children: [
        t(a.tooltip) && C(a.tooltip) && /* @__PURE__ */ r(
          y,
          {
            title: a.label,
            description: a.tooltip
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            className: e.label,
            children: a.label
          }
        ),
        /* @__PURE__ */ r("div", { className: e.barTrack, children: /* @__PURE__ */ r(
          "div",
          {
            className: c(e.bar, f),
            style: {
              // FIXME: use percent function
              width: `${g(a.value, N)}%`
            }
          }
        ) }),
        /* @__PURE__ */ r(
          V,
          {
            className: e.value,
            value: a.value,
            compact: d
          }
        )
      ]
    },
    a.key
  )) });
}
export {
  G as default
};
